var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideHeaderList.includes(_vm.$route.name)),expression:"!hideHeaderList.includes($route.name)"}]}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }